import React from 'react'
import classNames from 'classnames'

export type QuoteProps = React.ComponentPropsWithoutRef<'blockquote'>

export const Quote = ({ className, children, ...rest }: QuoteProps) => (
  <blockquote
    className={classNames('testimonial-card__quote', className)}
    {...rest}
  >
    {typeof children === 'string' ? <p>{children}</p> : children}
  </blockquote>
)
